import { AbstractControl, ValidatorFn } from '@angular/forms';
import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { ValidationError } from './validationError';

const VOLLJAEHRIGKEITSALTER = 18;
const LATEST_POSSIBLE_BAUJAHR = new Date().getFullYear() + 1;
const MIN_POSSIBLE_BAUJAHR = 1150;

export const wohnflaecheValidator = (
  wohnflaeche: number,
  maxAllowedFlaeche: number,
): ValidationError => {
  if (wohnflaeche > maxAllowedFlaeche) {
    return {
      isValid: false,
      wohnflaecheMax: true,
    };
  }
  return {
    isValid: true,
  };
};

export const baujahrValidator = (baujahr: number): ValidationError => {
  if (baujahr && (baujahr > LATEST_POSSIBLE_BAUJAHR || baujahr < MIN_POSSIBLE_BAUJAHR)) {
    return {
      isValid: false,
      pattern: true,
    };
  }
  return {
    isValid: true,
  };
};

export const geburtsdatumValidator = (geburtsdatumAsString: string): ValidationError => {
  const geburtsdatumAsDay = dayjs(geburtsdatumAsString, DATEFORMAT_LOCAL_STATE, true);
  const isValid = geburtsdatumAsDay.isValid();

  if (!isValid) {
    return { isValid: false };
  }

  const isInFuture = geburtsdatumAsDay.isAfter(dayjs());
  const age = dayjs().diff(geburtsdatumAsDay, 'year');
  const isMinderjaehrig = isValid && !isInFuture && age < VOLLJAEHRIGKEITSALTER;

  return {
    isValid: isValid && !isMinderjaehrig && !isInFuture,
    isMinderjaehrig,
    isInFuture,
  };
};

export class BasisangabenValidator {
  constructor(private readonly maxAllowedFlaeche: number = 0) {}

  validateWohnflaeche: ValidatorFn = (control: AbstractControl): ValidationError | null => {
    const validationResult = wohnflaecheValidator(control.value, this.maxAllowedFlaeche);
    const isValid = validationResult.isValid;
    return isValid ? null : validationResult;
  };

  validateBaujahr: ValidatorFn = (control: AbstractControl): ValidationError | null => {
    const validationResult = baujahrValidator(control.value);
    const isValid = validationResult.isValid;
    return isValid ? null : validationResult;
  };

  validateGeburtsdatum: ValidatorFn = (control: AbstractControl): ValidationError | null => {
    if (control.value) {
      const validationResult = geburtsdatumValidator(control.value);
      return validationResult.isValid ? null : validationResult;
    }
    return null;
  };
}
